export const query = `query getProductIdBySlug($slug: String!) {
  catalog {
    product(slug: $slug, onlyVisible: true) {
      id
    }
  }
}`;
